module.exports = function extend(target, source) {
  var prop;

  target = target || {};
  for (prop in source) {
    if (typeof source[prop] === 'object') {
      target[prop] = extend(target[prop], source[prop]);
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx-transpiler/src/helpers/merge.js
 ** module id = 420
 ** module chunks = 0
 **/